import { useTheme } from '@mui/material/styles';

import GaugeBase from './GaugeBase';

export default function OtherGauges({ chartData }) {
  const { palette } = useTheme();

  const n = chartData.length;
  let countPeers = 0;
  let countExisting = 0;
  let countUnclaimed = 0;

  for (const alertElement of chartData) {
    const { indicators, isTreeOnDashboard, unclaimedClinics } = alertElement;
    if (indicators.isPeerRequested) {
      countPeers++;
    }
    if (isTreeOnDashboard) {
      countExisting++;
    }
    if (unclaimedClinics.length > 0) {
      countUnclaimed++;
    }
  }
  return (
    <>
      <GaugeBase
        title='Peer Requested'
        value={countPeers}
        max={n}
        color={palette.error.main}
      />
      <GaugeBase
        title='Existing Patient'
        value={countExisting}
        max={n}
        color={palette.warning.main}
      />
      <GaugeBase
        title='Unclaimed'
        value={countUnclaimed}
        max={n}
        color={palette.primary.main}
      />
    </>
  );
}
